import { Component, Input, Output, EventEmitter } from "@angular/core";
import { ComparativeAnalysisService } from "src/app/comparative-analysis/comparative-analysis.service";
import { Subscription } from "rxjs";
import { NzTreeNode } from "ng-zorro-antd/tree";
import { CustomSkeletonConfig } from "src/app/shared/custom-skeleton/custom-skeleton-model";

@Component({
  selector: "app-industry-menu",
  templateUrl: "./industry-menu.component.html",
  styleUrls: ["./industry-menu.component.scss"],
})
export class IndustryMenuComponent {
  @Input() data;
  @Input() isLoading: boolean = false;
  @Input() searchedValue = "";
  @Input() marketCapData;
  @Input() geographyData;
  @Input() otherGeoLen;
  @Input() isCreateNewModalIndustryMenu: boolean = false;
  @Input() isMcapGeoDataLoading: boolean = false;
  @Input() shouldEmitTickerList: boolean = false;
  @Input() selectionInMegaMenu;
  @Output() onCancelButtonClick: EventEmitter<any> = new EventEmitter();
  @Output() onApplyButtonClick: EventEmitter<any> = new EventEmitter();
  @Output() onSearchValueChange: EventEmitter<any> = new EventEmitter();

  skeletonDefaultConfig: CustomSkeletonConfig = {
    skeletonType: "list",
    config: {
      list: {
        noOfListItems: 8,
      },
    },
  };
  expandKey = [];
  defaultKey = [];

  @Input() selectedMarketCaps: Array<number> = [-1];
  @Input() selectedCountires: Array<any> = [];
  @Input() selectedRegions: Array<number> = [-1];
  @Input() selectedIndustryData;
  industryId;
  subgroupId;
  sectorId;
  isSubgroupSelected;
  tickerList = [];
  // prevId;
  // prevParentId;

  totalTickerCount = 0;

  companyCountSubscriber: Subscription;

  constructor(private comparativeAnalysisService: ComparativeAnalysisService) {}

  ngOnChanges(changes) {
    if (
      changes.selectedIndustryData &&
      changes.selectedIndustryData.currentValue &&
      changes.selectedIndustryData.currentValue !==
        changes.selectedIndustryData.previousValue
    ) {
      this.industryId = this.selectedIndustryData.industry_id;
      this.subgroupId = this.selectedIndustryData.subgroup_id;
      this.sectorId = this.selectedIndustryData.parent_id;
      (this.expandKey = [
        `sector_${this.sectorId}`,
        `industry_${this.industryId}`,
      ]),
        (this.defaultKey = [
          `subindustry_${this.subgroupId}_${this.industryId}`,
        ]);
      this.isSubgroupSelected = true;
      this.fetchTickerCount();
    }
  }

  handleMenuOnclick(data) {
    if (data instanceof NzTreeNode) {
      data.isExpanded = !data.isExpanded;
    } else {
      const node = data.node;
      if (node) {
        node.isExpanded = !node.isExpanded;
      }
    }
    const isSubgroup = data.node.level === 2;
    if (isSubgroup && data.node.origin.selected) {
      const industryId = data.node.parentNode.origin.data_key;
      const subgroupId = data.node.origin.data_key;
      this.industryId = industryId;
      this.subgroupId = subgroupId;
      this.isSubgroupSelected = true;
      this.sectorId = data.node.parentNode.parentNode.origin.data_key;
      this.fetchTickerCount();
      // This is for removing previous selection, WIP, not working need some changes
      // if(!this.prevId){
      //   this.prevId = data.node.key;
      //   this.prevParentId = data.node.parentNode.key;
      // } else if (this.prevId === data.node.key && this.prevParentId === data.node.parentNode.key){
      //   data.node.origin.selected = false;
      // }
      // else {
      //   // this.data.forEach((node) => {
      //   //   node.children.forEach((child) => {
      //   //     if(this.prevParentId === child.key){
      //   //       child.expanded = false;
      //   //       child.children.forEach((leaf) => {
      //   //         if (this.prevId === leaf.key) {
      //   //           leaf.selected = false;
      //   //           leaf.expanded = false;
      //   //           console.log("leaf", leaf);
      //   //         }
      //   //       });
      //   //     }
      //   //   });
      //   // });
      // }
    } else {
      this.industryId = undefined;
      this.isSubgroupSelected = false;
      this.totalTickerCount = 0;
      data.node.origin.selected = false;
    }
  }

  handleCancelButtonClick() {
    this.onCancelButtonClick.emit();
  }

  handleApplyButtonClick() {
    if (this.totalTickerCount) {
      const result = {
        market_cap: this.selectedMarketCaps,
        country_id: this.selectedCountires
          ? this.selectedCountires.map((item) => {
              if (item[0] === "C") {
                return item.slice(1) * 1;
              }
              return item * 1;
            })
          : undefined,
        region_id: this.selectedRegions
          ? this.selectedRegions.length === this.otherGeoLen
            ? [-1]
            : this.selectedRegions.map((item) => {
                if (item[0] === "R") {
                  return item[1] * 1;
                }
                return item * 1; //This is to make sure that only array of number is passed as region_id
              })
          : undefined,
        industry_id: this.industryId,
        subindustry_id: [this.subgroupId],
        sector_id: this.sectorId,
        ticker_info: this.tickerList,
      };
      this.onApplyButtonClick.emit(result);
    }
  }

  handleMarketCapChange(data) {
    this.selectedMarketCaps = data;
    this.fetchTickerCount();
  }

  handleGeographyChange(data) {
    if (
      !data.isAllGeographySelected &&
      data.countries.length === 0 &&
      data.regions.length === 0
    ) {
      this.totalTickerCount = 0;
      this.selectedRegions = data.region;
    } else {
      if (data.countries) {
        this.selectedCountires = data.countries;
      }
      if (data.regions) {
        this.selectedRegions =
          data.regions.length === data.otherGeographyLen ? [-1] : data.regions;
      }
      this.fetchTickerCount();
    }
  }

  handleSearchValueChange(data) {
    this.onSearchValueChange.emit(data);
  }

  fetchTickerCount() {
    const payload = {
      market_cap: this.selectedMarketCaps,
      country_id: this.selectedCountires
        ? this.selectedCountires.map((item) => {
            if (item[0] === "C") {
              return item.slice(1) * 1;
            }
            return item * 1;
          })
        : undefined,
      region_id: this.selectedRegions
        ? this.selectedRegions.length === this.otherGeoLen
          ? [-1]
          : this.selectedRegions.map((item) => {
              if (item[0] === "R") {
                return item[1] * 1;
              }
              return item * 1; //This is to make sure that only array of number is passed as region_id
            })
        : undefined,
      industry_id: `${this.industryId}`,
      subindustry_id: [this.subgroupId],
      type: "industry",
    };
    if (this.shouldEmitTickerList) {
      payload["need_ticker_info"] = true;
    }
    if (this.industryId) {
      this.companyCountSubscriber = this.comparativeAnalysisService
        .fetchCompaniesCount(payload)
        .subscribe((response) => {
          if (response.status === "success") {
            this.totalTickerCount = response.count;
            this.tickerList = response.ticker_info;
          }
        });
    } else {
      this.totalTickerCount = 0;
    }
  }
}
